import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { CrossroadsLeadsActions } from "./index";
import {
    FETCH_CROSSROADS_LEADS_LIST_PROGRESS,
    FETCH_CROSSROADS_LEADS_LIST_SUCCESS,
    FETCH_CROSSROADS_LEADS_LIST_FAILURE,
    FETCH_CROSSROADS_LEADS_PROGRESS,
    FETCH_CROSSROADS_LEADS_SUCCESS,
    FETCH_CROSSROADS_LEADS_FAILED,
    FETCH_CROSSROADS_LEAD_STATUS_COUNT_PROGRESS,
    FETCH_CROSSROADS_LEAD_STATUS_COUNT_SUCCESS,
    FETCH_CROSSROADS_LEAD_STATUS_COUNT_FAILED,
    FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_PROGRESS,
    FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_SUCCESS,
    FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_FAILED,
    FETCH_CROSSROADS_FOLLOW_UP_HISTORY_PROGRESS,
    FETCH_CROSSROADS_FOLLOW_UP_HISTORY_SUCCESS,
    FETCH_CROSSROADS_FOLLOW_UP_HISTORY_FAILED,
    CLEAR_CROSSROADS_LEADS_STATE,
    CLEAR_CROSSROADS_LEADS,
    FETCH_CROSSROADS_TAB_DATA_FAILURE,
    FETCH_CROSSROADS_TAB_DATA_PROGRESS,
    FETCH_CROSSROADS_TAB_DATA_SUCCESS,
    FETCH_CUSTOMER_CONNECTION_DETAILS_PROGRESS,
    FETCH_CUSTOMER_CONNECTION_DETAILS_SUCCESS,
    FETCH_CUSTOMER_CONNECTION_DETAILS_FAILED,
    CLEAR_CROSSROADS_LEADS_LIST 
} from "./CrossroadsLeads.action";
import { InitialCrossroadsLeadsReduxState } from "./CrossroadsLeads.state";
import { ICrossroadsLead, ICrossroadsLeadStatusCount } from "./CrossroadsLeads.types";

export const crossroadsLeadsReducer = (
    state: IStoreState["crossroadsLeads"] = InitialCrossroadsLeadsReduxState,
    action: CrossroadsLeadsActions
) => {
    switch (action.type) {
        // ==================== Crossroads Leads REDUCERS ====================
        case FETCH_CROSSROADS_LEADS_LIST_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_CROSSROADS_LEADS_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.list = list;
                draftState.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_CROSSROADS_LEADS_LIST_FAILURE: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_CROSSROADS_LEADS_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.data.loading = LoadState.InProgress;
                draftState.data.data = null;
            });
            return newState;
        }
        case FETCH_CROSSROADS_LEADS_SUCCESS: {
            const { crossroadsLeads } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.data.loading = LoadState.Loaded;
                draftState.data.data = crossroadsLeads;
            });
            return newState;
        }
        case FETCH_CROSSROADS_LEADS_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.data.loading = LoadState.Failed;
                draftState.data.error = errorMessage;
            });
            return newState;
        }
        case FETCH_CROSSROADS_FOLLOW_UP_HISTORY_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.followUpHistory.loading = LoadState.InProgress;
                draftState.followUpHistory.list = [];
                draftState.followUpHistory.error = null;
            });
            return newState;
        }
        case FETCH_CROSSROADS_FOLLOW_UP_HISTORY_SUCCESS: {
            const { list } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.followUpHistory.loading = LoadState.Loaded;
                draftState.followUpHistory.list = list;
                draftState.followUpHistory.error = null;
            });
            return newState;
        }
        case FETCH_CROSSROADS_FOLLOW_UP_HISTORY_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.followUpHistory.loading = LoadState.Failed;
                draftState.followUpHistory.list = [];
                draftState.followUpHistory.error = errorMessage;
            });
            return newState;
        }

        case FETCH_CROSSROADS_LEAD_STATUS_COUNT_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.recordCounts.loading = LoadState.InProgress;
            });
        }
        case FETCH_CROSSROADS_LEAD_STATUS_COUNT_SUCCESS: {
            const { data } = action.payload;
            return produce(state, (draftState) => {
                draftState.recordCounts.loading = LoadState.Loaded;
                draftState.recordCounts.list = data as ICrossroadsLeadStatusCount[];
            });
        }
        case FETCH_CROSSROADS_LEAD_STATUS_COUNT_FAILED: {
            return produce(state, (draftState) => {
                draftState.recordCounts.loading = LoadState.Failed;
            });
        }

        case FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
        }
        case FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_SUCCESS: {
            const { list, totalRecords } = action.payload;
            return produce(state, (draftState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.list = list;
                draftState.list.totalRecords = totalRecords;
            });
        }
        case FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_FAILED: {
            return produce(state, (draftState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
        }
        case FETCH_CROSSROADS_TAB_DATA_PROGRESS: {
            const { tabType } = action.payload;
            return produce(state, (draftState) => {
                draftState[tabType].loading = LoadState.InProgress;
                draftState[tabType].list = [];
            });
        }

        case FETCH_CROSSROADS_TAB_DATA_SUCCESS: {
            const { data, totalRecords, tabType } = action.payload;
            return produce(state, (draftState) => {
                draftState[tabType].loading = LoadState.Loaded;
                draftState[tabType].list = data;
                draftState[tabType].totalRecords = totalRecords;
            });
        }

        case FETCH_CROSSROADS_TAB_DATA_FAILURE: {
            const { tabType } = action.payload;
            return produce(state, (draftState) => {
                draftState[tabType].loading = LoadState.Failed;
            });
        }
        case FETCH_CUSTOMER_CONNECTION_DETAILS_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.customerConnectionDetails.loading = LoadState.InProgress;
                draftState.customerConnectionDetails.list = [];
                draftState.customerConnectionDetails.totalRecords = 0;
                draftState.customerConnectionDetails.error = null;
            });
            return newState;
        }
        case FETCH_CUSTOMER_CONNECTION_DETAILS_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.customerConnectionDetails.loading = LoadState.Loaded;
                draftState.customerConnectionDetails.list = list;
                draftState.customerConnectionDetails.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_CUSTOMER_CONNECTION_DETAILS_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.customerConnectionDetails.loading = LoadState.Failed;
                draftState.customerConnectionDetails.error = errorMessage;
            });
            return newState;
        }
        case CLEAR_CROSSROADS_LEADS: {
            const newState = produce(state, (draftState) => {
                draftState.data.loading = LoadState.NotLoaded;
                draftState.data.data = null;
            });
            return newState;
        }
        case CLEAR_CROSSROADS_LEADS_STATE: {
            return InitialCrossroadsLeadsReduxState;
        }

        // created only for GraphMembershipLeadsTable to clear the list as the not count cards 
        case CLEAR_CROSSROADS_LEADS_LIST: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.NotLoaded;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        default: {
            return state;
        }
    }
}